import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { pagoService } from '../services/api';
import '../styles/Clientes.css';

const CobrosHoy = () => {
  const [pagos, setPagos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { codigo } = useParams();

  // Función para construir rutas con el código del tenant
  const getRoute = (path) => {
    return codigo ? `/${codigo}${path}` : path;
  };

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      setError('');

      // Obtener todos los pagos
      const hoy = new Date().toISOString().split('T')[0];
      const responsePagos = await pagoService.getPagos();
      console.log('Response completa de pagos:', responsePagos);
      const todosPagos = responsePagos.data.pagos || [];
      console.log('Todos los pagos:', todosPagos);

      // Filtrar pagos de hoy
      const pagosHoy = todosPagos.filter(pago => {
        const fechaPago = new Date(pago.fecha_pago).toISOString().split('T')[0];
        return fechaPago === hoy;
      });
      console.log('Pagos de hoy:', pagosHoy);
      setPagos(pagosHoy);

    } catch (err) {
      console.error('Error:', err);
      setError(err.response?.data?.error || 'Error al cargar los datos');
    } finally {
      setLoading(false);
    }
  };

  const formatMoney = (amount) => {
    return `$${(amount || 0).toLocaleString('es-DO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  const totalCobrado = pagos.reduce((sum, pago) => sum + (pago.monto_total || 0), 0);

  if (loading) return <div className="loading">Cargando...</div>;

  return (
    <div className="clientes-page">
      <div className="clientes-header">
        <h1>Cobros Hoy</h1>
        <button
          className="btn"
          onClick={() => navigate(getRoute('/dashboard'))}
          style={{background: '#666', color: '#fff'}}
        >
          ← Volver al Dashboard
        </button>
      </div>

      {error && <div className="banner error">{error}</div>}

      {/* Resumen Total Cobrado */}
      <div className="card" style={{marginBottom: '2rem', background: '#27ae60', color: '#fff', padding: '2rem', textAlign: 'center'}}>
        <h2 style={{margin: 0}}>Total Cobrado Hoy</h2>
        <div style={{fontSize: '2.5rem', fontWeight: 'bold', marginTop: '1rem'}}>
          {formatMoney(totalCobrado)}
        </div>
        <div style={{marginTop: '0.5rem', opacity: 0.9}}>
          {pagos.length} pago{pagos.length !== 1 ? 's' : ''} registrado{pagos.length !== 1 ? 's' : ''}
        </div>
      </div>

      {/* Detalle de Pagos */}
      <div className="card">
        <div className="card-title" style={{background: '#27ae60'}}>
          Detalle de Pagos de Hoy
        </div>

        <p style={{padding: '1rem'}}>
          Mostrando registros del 1 al {pagos.length} de un total de {pagos.length} registros
        </p>

        {pagos.length === 0 ? (
          <p style={{padding: '1rem', textAlign: 'center', color: '#666'}}>
            No hay pagos registrados para hoy
          </p>
        ) : (
          <div style={{overflowX: 'auto'}}>
            <table className="table">
              <thead>
                <tr>
                  <th>ID Pago</th>
                  <th>ID Préstamo</th>
                  <th>Cliente</th>
                  <th>Monto</th>
                  <th>Fecha</th>
                  <th>Hora</th>
                </tr>
              </thead>
              <tbody>
                {pagos.map((pago) => {
                  const cliente = pago.prestamo?.cliente || pago.cliente;
                  const nombreCompleto = cliente
                    ? `${cliente.nombres || ''} ${cliente.apellidos || ''}`.trim()
                    : 'Sin información';

                  return (
                    <tr key={pago.id}>
                      <td>{pago.id}</td>
                      <td>{pago.prestamo_id}</td>
                      <td>{nombreCompleto}</td>
                      <td style={{fontWeight: 'bold', color: '#27ae60'}}>{formatMoney(pago.monto_total)}</td>
                      <td>{new Date(pago.fecha_pago).toLocaleDateString('es-DO')}</td>
                      <td>
                        {pago.created_at ? new Date(pago.created_at).toLocaleTimeString('es-DO', {
                          hour: '2-digit',
                          minute: '2-digit'
                        }) : '-'}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default CobrosHoy;
